export default "Calorifugeage points singuliers — Fiche CEE IND-UT-103 | Solution Éco France";
